import React from 'react'
import styled from 'styled-components'
import Home from '../pages/Home/Home'
import Lists from '../pages/Lists/Lists'
import Detail from '../pages/Detail/Detail'
import Header from '../components/Header/Header'
import { Route, Routes } from 'react-router-dom'
import Footer from '../components/Footer/Footer'

export const Page = styled.section`
    /* background-color: red; */
    min-height: 100vh;
    @media (min-width: 768px) {
    }
`

export default function Pages() {
  return (
    <Page>
        <Header />
        <Routes>
            <Route path='/' element={<Home/>} />
            <Route path='/lists' element={<Lists/>} />
            <Route path='/detail' element={<Detail/>} />
        </Routes>
        <Footer />
    </Page>
  )
}
